import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { JobUnassignedReasonsComponent } from './job-unassigned-reasons.component';

const routes: Routes = [
  { path: '', component: JobUnassignedReasonsComponent, data: { title: 'Job Unassigned Reasons' } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class JobUnassignedReasonsRoutingModule {}

@NgModule({
  imports: [
    JobUnassignedReasonsRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
  ],
  declarations: [JobUnassignedReasonsComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class JobUnassignedReasonsModule {}
